import '../styles/trust-strip.css';

const TrustStrip = () => {
  const items = [
    "🔒 Bank-Level Encryption",
    "🪪 NRC-Verified Sellers",
    "💬 Private In-App Chat",
    "📍 10+ Zambian Cities",
    "⭐ 4.8 App Rating",
    "🚗 20,000+ Active Listings",
    "🇿🇲 Built in Zambia",
    "📲 Free to Download",
  ];

  return (
    <section className="trust-strip">
      <span className="trust-label">Trusted By</span>
      <div className="marquee-wrap">
        <div className="marquee-track">
          {[...items, ...items].map((item, i) => (
            <span className="trust-item" key={i}>{item}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
